/**
 * Tiny hash router. ~40 lines, no dependencies.
 *
 * Routes:
 *   #/                              → home (athletes list)
 *   #/athletes/:uuid                → athlete deep-dive (default tab: dashboards)
 *   #/athletes/:uuid/dashboards     → dashboards tab
 *   #/athletes/:uuid/files          → files tab
 *   #/athletes/:uuid/notes          → notes tab
 *   #/athletes/:uuid/profile        → profile tab
 *   anything else                   → not-found
 *
 * Usage:
 *   import { parseRoute, navigate, onRouteChange } from './router.js';
 *   onRouteChange((route) => render(route));
 */

export const ATHLETE_TABS = ['dashboards', 'files', 'notes', 'profile'];

export function parseRoute(hash = location.hash) {
  const path = hash.startsWith('#') ? hash.slice(1) : hash;
  const clean = path || '/';

  if (clean === '/' || clean === '') {
    return { name: 'home', params: {} };
  }

  // Athlete with optional tab segment.
  const athleteMatch = clean.match(/^\/athletes\/([0-9a-f-]+)(?:\/([a-z-]+))?\/?$/i);
  if (athleteMatch) {
    const id = athleteMatch[1];
    const requestedTab = athleteMatch[2]?.toLowerCase() ?? 'dashboards';
    const tab = ATHLETE_TABS.includes(requestedTab) ? requestedTab : 'dashboards';
    return { name: 'athlete', params: { id, tab } };
  }

  return { name: 'not-found', params: {}, attempted: clean };
}

export function navigate(path) {
  const target = path.startsWith('#') ? path : '#' + path;
  if (location.hash === target) return;
  location.hash = target;
}

export function onRouteChange(handler) {
  window.addEventListener('hashchange', () => handler(parseRoute()));
  // Fire once on first load so the initial route renders.
  queueMicrotask(() => handler(parseRoute()));
}
